import {configureStore}  from '@reduxjs/toolkit';
import authReducer from './reducers/authReducer.js';
import pcardReducer from './reducers/pcardReducer.js';
import gcardReducer from './reducers/gcardReducer.js';
 const store = configureStore({
    reducer:{
        auth:authReducer,
        bussinesCard:pcardReducer,
        googleCard:gcardReducer
    }
});

export default store;